import { Controller } from '../utils/controller';
import { type ValueDefinitionMap } from '@hotwired/stimulus/dist/types/core/value_properties';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pwr: any;
  }
}

interface Variant {
  id: string;
  images: [Image];
}

interface Image {
  src: string;
}

interface FeedlessData {
  category_name: string;
  description: string;
  image_url: string;
  name: string;
  price: string;
  variants: [Variant];
}

export default class extends Controller {
  static targets: string[] = [
    'reviewDisplay',
    'reviewSnippet',
    'questionDisplay',
    'questionSnippet',
    'writeReview'
  ];
  static requiredTargets = [];

  static values: ValueDefinitionMap = {
    id: String,
    feedlessData: Object,
    locale: String,
    apiKey: String,
    merchantGroupId: String,
    merchantId: String,
    wrapperUrl: String
  };

  // TARGETS
  declare questionDisplayTarget: HTMLElement;
  declare questionSnippetTarget: HTMLElement;
  declare readonly hasQuestionDisplayTarget: boolean;
  declare readonly hasQuestionSnippetTarget: boolean;
  declare readonly hasReviewDisplayTarget: boolean;
  declare readonly hasReviewSnippetTarget: boolean;
  declare readonly hasWriteReviewTarget: boolean;
  declare reviewDisplayTarget: HTMLElement;
  declare reviewSnippetTarget: HTMLElement;
  declare writeReviewTarget: HTMLElement;

  // LOCAL STATE
  private localeValue: string;
  private apiKeyValue: string;
  private merchantGroupIdValue: string;
  private merchantIdValue: string;
  private wrapperUrlValue: string;
  private idValue: string;
  private feedlessDataValue: FeedlessData;

  initialize() {
    if (this.hasWriteReviewTarget) {
      this.renderWriteReviewForm();
    }
    if (this.hasReviewDisplayTarget || this.hasReviewSnippetTarget) {
      this.renderPowerReviewsDisplay();
    }
  }

  renderPowerReviewsDisplay() {
    window.pwr =
      window.pwr ||
      function (...args) {
        (window.pwr.q = window.pwr.q || []).push(args);
      };

    window.pwr('render', {
      api_key: this.apiKeyValue,
      locale: this.localeValue,
      merchant_group_id: this.merchantGroupIdValue,
      merchant_id: this.merchantIdValue,
      page_id: this.idValue,
      review_wrapper_url: this.wrapperUrlValue + this.idValue,
      product: this.feedlessDataValue,
      components: {
        ...(this.hasReviewDisplayTarget && {
          ReviewDisplay: this.reviewDisplayTarget?.id
        }),
        ...(this.hasReviewSnippetTarget && {
          ReviewSnippet: this.reviewSnippetTarget?.id
        }),
        ...(this.hasQuestionDisplayTarget && {
          QuestionDisplay: this.questionDisplayTarget?.id
        }),
        ...(this.hasQuestionSnippetTarget && {
          QuestionSnippet: this.questionSnippetTarget?.id
        })
      }
    });
  }

  renderWriteReviewForm() {
    window.pwr =
      window.pwr ||
      function (...args) {
        (window.pwr.q = window.pwr.q || []).push(args);
      };
    window.pwr('render', {
      page_id: this.idValue,
      api_key: this.apiKeyValue,
      locale: this.localeValue,
      merchant_group_id: this.merchantGroupIdValue,
      merchant_id: this.merchantIdValue,
      on_submit: (/* config, data */) => {
        window.scrollTo(0, 0);
      },
      components: {
        Write: 'pr-write'
      }
    });
  }

  writeAReview() {
    location.assign(
      `${window.location.origin}${this.wrapperUrlValue}&pr_merchant_id=${this.merchantIdValue}&pr_merchant_group_id=${this.merchantGroupIdValue}`
    );
  }

  toggleReviewsQuestionDisplay() {
    // eslint-disable-next-line
    console.warn('Toggle for Reviews and Ask & Answer has not been implemented!');
  }
}
